<template>
	<div class="g-page flex">
		<div style="position: fixed; top: -100px;">
			<input type="text" name="username">
			<input type="password" name="password">
		</div>

		<div class="g-aside flex-column" :fold="asideFoldState">
			<div class="logo flex-column flex-center">
				<div class="logo-image">
					<img :src="require('@/assets/image/icon.png')" alt="">
				</div>
				<p>机老大管家</p>
			</div>
			<ul class="sys flex-center">
				<li :class="{'z-crt': activeSys == 2}" @click="activeSys = 2">运营管理</li>
				<li v-if="erpMenuCount" :class="{'z-crt': activeSys == 3}" @click="activeSys = 3">ERP数据查看</li>
			</ul>
			<c-scroll class="menu flex-grow" bar-color="rgba(255,255,255,.5)">
				<dl v-for="(menu, i) in navList" v-show="activeSys == menu.first_menu_id" :key="i" :ref="`menu-${i}`" class="item" :class="{'z-alive': aliveMenu == menu.menu_unique_key}" @mouseenter="menuMouseInHandle(menu, i)">
					<dt class="flex-center-cross" @click="navHandle(menu, menu)">
						<i class="icon tf" :class="`tf-nav-${menu.menu_unique_key}`"></i>
						<p class="flex-grow">{{menu.menu_name}}</p>
						<i v-if="menu.child_menu_list" class="angle tf-angle-right"></i>
					</dt>
					<dd v-if="menu.child_menu_list" :style="{'height': aliveMenu == menu.menu_unique_key && !asideFoldState ? `${menu.child_menu_list.length * 36 + 20}px` : 0}">
						<div :class="{'sub-menu': subMenuState}" :style="subMenuState ? subMenuStyle[menu.menu_unique_key] : ''">
							<c-scroll bar-color="rgba(255,255,255,.5)">
								<ul>
									<li v-for="(item, j) in menu.child_menu_list" :key="j" class="flex-center-cross" :class="{'z-alive': alivePage == item.menu_unique_key}" :parent="item.is_parent" :child="item.is_child" @click="item.is_parent ? '' : navHandle(item, menu)">
										<p>{{item.menu_name}}</p>
									</li>
								</ul>
							</c-scroll>
						</div>
					</dd>
				</dl>
			</c-scroll>
			<!-- <div class="bottom flex-end-center">
				<a class="flex-center" @click="asideFoldState = !asideFoldState"><i class="tf">&#xe6f9;</i></a>
			</div> -->
		</div>

		<div class="flex-grow flex-column">
			<div class="g-head flex">
				<div class="flex-grow flex-between-center">
					<div class="head-crumb flex-center">
						<template v-for="(item, i) in crumbList">
							<span v-if="i > 0"><i class="tf">&#xeb08;</i></span>
							<p :key="i">{{item}}</p>
						</template>
					</div>
						
					<div class="flex">
						<div v-for="(item, i) in headButtonList" :key="i" class="head-button" :active="activeHeadButton == item">
							<div class="head-button-main flex-center" @click.stop="headButtonHandle(item)">
								<i class="icon" :class="[item.icon]"></i>
								<span>{{item.name}}</span>
							</div>
							<ul v-if="item.list" class="head-button-list">
								<li v-for="(child, j) in item.list" :key="j" class="flex-center-cross" @click.stop="headButtonHandle(child)">{{child.name}}</li>
							</ul>
						</div>
						<div class="user-info flex-center">
							<div class="icon flex-center">
								<img src="@/assets/image/head_icon.jpg" alt="">
							</div>
							<span class="name">{{userInfo.user_realname}}</span>
							<i class="arrow tf-tri-down"></i>
							
							<div class="menu">
								<!-- <div class="item" @click="$refs.updateLog.open()">更新日志</div> -->
								<div class="item" @click="$refs.resetPsw.open()">修改密码</div>
								<div class="item" @click="logout">安全退出</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="g-content flex-grow">
				<router-view ref="routerView"></router-view>
			</div>
		</div>

		<c-dialog ref="resetPsw" title="修改密码" width="440" @resolve="resetPassword">
			<c-form ref="resetPswForm">
				<c-form-item label="旧密码" required>
					<c-input type="password" name="old_pwd" visible></c-input>
				</c-form-item>
				<c-form-item label="新密码" required>
					<c-input type="password" name="user_pwd" visible></c-input>
				</c-form-item>
				<c-form-item label="确认密码" required>
					<c-input type="password" name="confirm_pwd" visible></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>
	</div>
</template>

<script>
	import {cryptoJs} from '@deanwu/vue-component-library'
	import {mapState} from 'vuex'
	
	export default {
		name: 'Sys',

		data() {
			return {
				asideFoldState: !!parseInt(localStorage.getItem('asideFoldState')),
				subMenuState: !!parseInt(localStorage.getItem('asideFoldState')),
				activeSys: 0,
				aliveMenu: null,
				alivePage: null,
				subMenuStyle: {},

				crumbList: [],
				printConfig: false,
				appViewConfig: false,
				activeHeadButton: null,
				exportListConfig: false,

				updateLog: new Array(10)
			}
		},
		
		computed: {
			...mapState(['saasInfo', 'userInfo', 'navList']),

			erpMenuCount() {
				return this.navList.filter(item => item.first_menu_id == 3).length;
			},
			
			headButtonList() {
				let arr = [];
				if (this.exportListConfig) {
					arr.push({
						name: '导出模板',
						icon: 'tf-export',
						handle: () => {
							this.globalDialog('exportTemplate', {
								props: this.exportListConfig
							})
						}
					});
				}
				if (this.printConfig) {
					arr.push({
						name: '打印模板',
						icon: 'tf-print',
						handle: () => {
							this.globalDialog('printTemplate', {
								props: this.printConfig
							})
						}
					});
				}
				if (this.appViewConfig) {
					arr.push({
						name: '移动端卡片',
						icon: 'tf-phone',
						list: this.appViewConfig.detailView ? [{
							name: '列表卡片',
							handle: () => {
								this.globalDialog('appViewConfig', {
									props: this.appViewConfig,
									data: {
										name: '列表'
									}
								})
							}
						}].concat(
							this.appViewConfig.detailView.map(item => {
								return {
									name: `详情-${item.name}`,
									handle: () => {
										this.globalDialog('appViewConfig', {
											props: item,
											data: {
												name: `详情-${item.name}`
											}
										})
									}
								}
							})
						) : null,
						handle: this.appViewConfig.detailView ? null : () => {
							this.globalDialog('appViewConfig', {
								props: this.appViewConfig,
								data: {
									name: '列表'
								}
							})
						}
					});
				}
				return arr;
			}
		},
		
		watch: {
			$route(val) {
				this.parseRoute(val);
				if (val.name == '404') {
					this.aliveMenu = this.alivePage = null;
					return;
				};
				this.updateAlivePage();
			},

			asideFoldState(val) {
				localStorage.setItem('asideFoldState', val ? 1 : 0);

				if (val) {
					this._asideTimer = setTimeout(() => {
						this.subMenuState = true;
					}, 500);
				} else {
					clearTimeout(this._asideTimer);
					this.subMenuState = false;
				}

				clearTimeout(this._asideFoldEndTimer);
				clearInterval(this._asideFoldTimer);
				this._asideFoldTimer = setInterval(() => {
					if (this.$refs.routerView.$options.name == 'home') {
						this.$refs.routerView.resize('asideFold');
					}
				}, 10);
				this._asideFoldEndTimer = setTimeout(() => {
					clearInterval(this._asideFoldTimer);
				}, 550);
			}
		},
		
		mounted() {
			this.parseRoute();
			this.updateAlivePage();
			window.addEventListener('click', () => {
				this.activeHeadButton = null;
			}, true);
		},
		
		methods: {
			menuMouseInHandle(menu, i) {
				if (this.asideFoldState) {
					let rect = this.$refs[`menu-${i}`][0].getBoundingClientRect();
					let height = menu.child_menu_list ? menu.child_menu_list.length * 36 + 20 : 0;
					let topHeight = window.innerHeight - rect.top - 20;
					let maxHeight = window.innerHeight - 40;
					this.$set(this.subMenuStyle, menu.menu_unique_key, {
						'top': (maxHeight < height ? 20 : topHeight < height ? rect.top - (height - topHeight) : rect.top) + 'px',
						'height': Math.min(height, maxHeight) + 'px'
					});
				}
			},

			navHandle(item, menu) {
				if (!item.menu_unique_key) return;
				if (
					item == menu && (!this.asideFoldState || !item.child_menu_list)
					||
					item != menu && this.asideFoldState
				) {
					if (this.aliveMenu == menu.menu_unique_key) {
						this.aliveMenu = '';
					} else {
						this.aliveMenu = menu.menu_unique_key;
					}
				}
				
				if (!item.child_menu_list) {
					this.alivePage = item.menu_unique_key;
					if (item.menu_unique_key == 'home' || this.$router.resolve({name: item.menu_unique_key}).href != '/') {
						this.navigateTo({
							name: item.menu_unique_key
						});
					} else if (item.menu_unique_key.indexOf('m_custom_') == 0) {
						this.navigateTo(`/custom/field/${item.menu_unique_key.substring(item.menu_unique_key.lastIndexOf('_') + 1)}`);
					} else {
						this.navigateTo({
							name: item.menu_unique_key
						});
					}
				}
			},

			parseRoute(route = this.$route) {
				let crumb = [];
				!function loop(index, list) {
					let item = route.matched[index];
					if (!item || !list) return;
					if (item.name) {
						let menu;
						if (item.name == 'm_custom_field') {
							menu = list.find(temp => temp.menu_unique_key == `m_custom_${route.params.type}`);
						} else {
							menu = list.find(temp => temp.menu_unique_key == item.name);
						}
						menu && crumb.push(menu.menu_name);
						list = menu ? menu.child_menu_list : undefined;
					}
					loop(++index, list);
				}(0, this.navList);
				this.crumbList = crumb;
				
				['exportList','print', 'appView'].forEach(key => {
					this[`${key}Config`] = route.meta[key] && (!route.meta[key].auth || this.auth(route.meta[key].auth)) ? route.meta[key] : false;
				});
			},

			updateAlivePage(route = this.$route) {
				if (route.name == '404') {
					this.navigateTo('/');
					return;
				};

				if (route.name == 'm_custom_field') {
					this.alivePage = `m_custom_${route.params.type}`;
				} else {
					this.alivePage = route.name;
				}
				if (this.alivePage) {
					let menu = this.navList.find(menu => {
						return menu.child_menu_list ? menu.child_menu_list.find(item => {
							return item.menu_unique_key == this.alivePage;
						}) : menu.menu_unique_key == this.alivePage;
					});
					menu && (this.activeSys = menu.first_menu_id);
					menu && (this.aliveMenu = menu.menu_unique_key);
				}
			},

			headButtonHandle(item) {
				if (item.list) {
					this.activeHeadButton = item;
				} else {
					this.activeHeadButton = null;
				}
				item.handle && item.handle();
			},
			
			logout() {
				this.$confirm({
					message: '确定要退出登录吗？',
					resolve: () => {
						this.request({
							url: '/sys_user/logout',
							loading: true,
							success: () => {
								this.$store.commit('setSession', '');
								this.navigateTo('/login');
							}
						});
					}
				});
			},
			
			resetPassword(stop) {
				stop();
				this.$refs.resetPswForm.submit({
					url: '/sys_user/update_pwd',
					rule: {
						old_pwd: '请填写旧密码',
						user_pwd: '请填写新密码',
						confirm_pwd: [{
							type: 'empty',
							message: '请在填写一次新密码'
						}, {
							type: 'function',
							fun: (value, data) => {
								return data.user_pwd == value
							},
							message: '两次输入的新密码不一致'
						}]
					},
					dataFormatter: data => {
						data.old_pwd = cryptoJs.MD5(data.old_pwd).toString();
						data.user_pwd = cryptoJs.MD5(data.user_pwd).toString();
						delete data.confirm_pwd;
						return data;
					},
					success: () => {
						this.$message({
							type: 'success',
							message: '密码修改成功'
						});
						this.$refs.resetPsw.close();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.g-page {
		height: 100vh;
		
		.g-aside {
			z-index: 100;
			position: relative;
			width: 200px;
			background: #132033;
			transition: width .5s ease;

			&[fold] {
				width: 60px;
			}
			
			.logo {
				position: relative;
				min-height: 90px;

				&-image {
					position: relative;
					height: 44px;
					pointer-events: none;
				
					img {
						max-width: none;
						height: 100%;
					}
				}

				p {
					margin-top: 10px;
					font-size: 18px;
					white-space: nowrap;
					color: #fff;
					opacity: 1;
					pointer-events: none;
					transition: opacity .2s ease;

					^[-2][fold] ^[-2..-1] {
						opacity: 0;
					}
				}

				span {
					position: absolute;
					left: 0;
					top: 0;
					border-radius: 0 12px 12px 0;
					padding: 0 9px 0 6px;
					line-height: 24px;
					font-size: 14px;
					font-weight: 500;
					white-space: nowrap;
				}
			}

			.sys {
				border-bottom: 1px solid rgba(255,255,255,.2);
				margin-top: 10px;

				+ .menu {
					margin-top: 5px;
				}

				li {
					position: relative;
					padding: 0 10px;
					line-height: 54px;
					font-size: 13px;
					color: #fff;
					cursor: pointer;

					&:hover {
						color: #FFBA00;
					}

					&:after {
						content: '';
						position: absolute;
						left: 50%;
						bottom: -1px;
						width: 0;
						height: 2px;
						background: #FFBA00;
						transform: translate(-50%,0);
						transition: width .3s ease;
					}

					&.z-crt {
						font-size: 16px;
						font-weight: bold;
						color: #FFBA00;

						&:after {
							width: 40px;
						}
					}
				}
			}
			
			.menu {
				margin-top: 15px;

				.item {
					width: 200px;
					margin-top: 5px;
					transition: background .3s ease, width .5s ease;

					^[-2][fold] ^[-2..-1] {
						width: 60px;

						&:hover {
							.sub-menu {
								display: block;
							}
						}
					}

					^[-2]:not([fold]) ^[-2..-1].z-alive dd {
						background: #1E2D43;
					}

					dt {
						height: 46px;
						overflow: hidden;
						color: #fff;
						cursor: pointer;
						transition: all .2s ease;

						^[-3][fold] ^[-3..-1] {
							border-radius: 6px;
							padding: 0 13px;
							margin: 0 5px;
							color: #fff;
						}

						^[-3][fold] ^[-2..-2]:hover ^[-1..-1] {
							background: var(--color-main);
						}

						^[-3]:not([fold]) ^[-3..-1] {
							border-radius: 6px;
							padding: 0 14px 0 10px;
							margin: 0 5px;

							&:hover {
								background: var(--color-main);
							}
						}
						
						^[-1].z-alive ^[-1..-1] {
							color: #fff;
							background: var(--color-main);

							.angle {
								transform: rotate(90deg);
							}
						}
						
						.icon {
							width: 1em;
							font-size: 16px;
							text-align: center;

							^[-4][fold] ^[-3..-1] {
								min-width: 24px;
								font-size: 18px;
							}
						}

						p {
							margin: 0 12px;
							font-size: 15px;
							font-weight: bold;
							white-space: nowrap;
							opacity: 1;
							pointer-events: none;
							transition: opacity .2s ease;

							^[-4][fold] ^[-3..-1] {
								opacity: 0;
							}
						}

						.angle {
							font-size: 13px;
							opacity: 1;
							pointer-events: none;
							transition: transform .3s ease, opacity .2s ease;

							^[-4][fold] ^[-3..-1] {
								opacity: 0;
							}
						}
					}
					
					dd {
						padding: 0 10px;
						overflow: hidden;
						transition: height .3s ease;
						
						^[-1].z-alive ^[-1..-1] {
							height: auto;
						}

						ul {
							padding: 10px 0;
						}
						
						li {
							&[parent] {
								position: relative;
								height: 36px;
								padding: 0 16px;
								font-size: 13px;
								white-space: nowrap;
								color: #D9E0E9;

								&:before {
									content: '';
									width: 5px;
									height: 2px;
									border-radius: 1px;
									margin-right: 10px;
									background: #eee;
								}
							}
							
							&[child] {
								height: 36px;
								padding-left: 42px;
								font-size: 13px;
								white-space: nowrap;
								color: #D9E0E9;
								cursor: pointer;
								transition: all .3s ease;
								
								&:hover,
								&.z-alive {
									color: #fff;
								}

								&.z-alive {
									background: #354256;
								}
							}

							&:not([child]):not([parent]) {
								position: relative;
								height: 36px;
								padding: 0 14px;
								font-size: 13px;
								white-space: nowrap;
								color: #D9E0E9;
								cursor: pointer;
								transition: all .3s ease;
								
								&:hover,
								&.z-alive {
									color: #fff;
								}

								&.z-alive {
									border-radius: 4px;
									background: #354256;
								}

								&:before {
									content: '';
									width: 5px;
									height: 2px;
									border-radius: 1px;
									margin-right: 10px;
									background: #eee;
									transition: all .2s ease;

									^[-1]:hover^[-1..-1],
									^[-1].z-alive^[-1..-1] {
										width: 12px;
										background: #fff;
									}
								}
							}
						}
					}
				}
			}

			.sub-menu {
				display: none;
				position: fixed;
				left: 60px;
				padding-left: 6px;
				animation: subMenuFadeIn .4s;
				
				@keyframes subMenuFadeIn {
					0% {
						opacity: 0;
						transform: translate(0,10px);
					}

					100% {
						opacity: 1;
						transform: translate(0,0);
					}
				}

				>>> .c-scroll {
					border-radius: 4px;
					background: #1E2D43;
				}

				ul {
					box-sizing: border-box;
					width: 180px;
					padding: 10px;

					li {
						&.z-alive {
							background: #354256 !important;
						}
					}
				}
			}

			.bottom {
				min-height: 40px;
				border-top: 1px solid #2B3748;
				padding: 0 10px 0 18px;
				color: #fff;
				background: #132033;
				transition: padding .2s ease;

				^[-1][fold] ^[-1..-1] {
					padding: 0 15px;
				}

				a {
					width: 30px;
					height: 30px;
					font-size: 16px;
					opacity: .6;

					&:hover {
						opacity: 1;
					}

					^[-2][fold] ^[-2..-1] {
						transform: rotate(180deg);
					}
				}
			}
		}
		
		.g-head {
			z-index 50;
			position: relative;
			height: 50px;
			background: #fff;
			box-shadow: 0 1px 5px 0 rgba(0,0,0,.1);
			
			.head-crumb {
				gap: 10px;
				padding-left: 20px;
				color: #999;

				p:nth-last-child(1) {
					color: #000;
				}
			}
			
			.head-button {
				position: relative;

				&:nth-child(n+2) {
					margin-left: 25px;
				}

				&-main {
					height: 50px;
					font-size: 13px;
					color: #444;
					cursor: pointer;

					.tf {
						margin-right: 6px;
						font-size: 16px;
					}

					&:hover,
					^[-1][active] ^[-2..-1] {
						color: var(--color-main);
					}
				}

				ul {
					display: none;
					z-index: 90;
					position: absolute;
					left: 0;
					top: 100%;
					border: 1px solid #eee;
					background: #fff;
					box-shadow: 0 5px 5px 0 rgba(0,0,0,.05);

					^[-1][active] ^[-1..-1] {
						display: block;
					}

					li {
						height: 36px;
						padding: 0 16px;
						white-space: nowrap;
						font-size: 13px;
						color: #444;
						cursor: pointer;

						&:nth-child(n+2) {
							border-top: 1px solid #eee;
						}

						&:hover {
							color: var(--color-main);
						}
					}
				}
			}
			
			.user-info {
				z-index: 100;
				position: relative;
				height: 50px;
				padding: 0 20px;
				cursor: pointer;
				transition: all .3s ease;
				
				&:hover {
					.menu {
						display: block;
					}
				}
				
				.icon {
					width: 34px;
					height: 34px;
					border-radius: 100%;
					overflow: hidden;
				}
				
				.name {
					margin: 0 6px 0 10px;
					font-size: 13px;
				}
				
				.arrow {
					font-size: 11px;
				}
				
				.menu {
					display: none;
					z-index: 12;
					position: absolute;
					left: 0;
					right: 0;
					top: 100%;
					padding: 8px 0;
					color: #000;
					background: #fff;
					box-shadow: 0 5px 5px 0 rgba(0,0,0,.05);
					
					.item {
						position: relative;
						padding: 0 10px 0 16px;
						line-height: 36px;
						font-size: 13px;
						color: #333;
						
						&:hover {
							background: #F5F5F5;
							theme-color(main);
							
							.theme-list {
								display: block;
							}
						}
						
						.tf {
							font-size: 12px;
							color: #333;
						}
						
						.theme-list {
							display: none;
							position: absolute;
							right: 100%;
							top: 0;
							width: 100px;
							padding: 8px 0;
							background: #fff;
							box-shadow: 0 3px 10px 0 rgba(0,0,0,.15);
						}
					}
				}
			}
		}
		
		.g-content {
			overflow: auto;
			background: #F5F4F7;
		}
	}
</style>
